import { createFileRoute } from '@tanstack/react-router';

// The content with no slide modal open
export const Route = createFileRoute('/_authenticated/slideshows/$id/_content/')({});
